import { useCallback } from 'react';
import { usePreferences } from '../../hooks/usePreferences';
import { DEFAULT_COUNTRY, COUNTRIES, Country } from '../../constants';
import { useUpdateUserMutation } from '../../hooks/useUser/useUpdateUserMutation';
import { useUser } from '../../hooks/useUser';

export const useCountry = () => {
  const { countryId } = usePreferences();
  const country: Country = countryId
    ? COUNTRIES.find(({ id }) => id === countryId) || DEFAULT_COUNTRY
    : DEFAULT_COUNTRY;

  return { country };
};

export const useSetCountry = () => {
  const { setPreference } = usePreferences();
  const { user, setUserData } = useUser();
  const [updateUser] = useUpdateUserMutation();

  const setCountry = useCallback(
    ({ id, alpha2Code }: Country) => {
      if (!user.isLoggedIn) {
        setPreference('countryId', id);
        return;
      }
      updateUser({
        country_code: alpha2Code
      }).then(response => {
        if (response) {
          const { attributes } = response;
          setUserData({ ...user, ...attributes });
          setPreference('countryId', id);
        }
      });
    },
    [setUserData, setPreference, updateUser, user]
  );

  return { setCountry };
};
